type FeatureFlag = {
  id: string
  feature: Feature
  enabled: boolean
  companyId?: string
  companyUserId?: string
  productId?: number
}

export const enum Feature {
  AddNewPerk = 0,
  PostMethodImpersonationCsi = 1,
  Adp = 2,
  AdminOptInOptOutEmployee = 3,
  C1095Report = 4,
  LoginSignUpDescription = 5,
  CountEligibleAdminsOptedOutInOccupiedSeats = 6,
  ShowCoveredDependents = 7,
  PastYearW2Report = 8,
  NotifyAdminsForReimbursementsDueSms = 9,
  ShowHSAModalOnGetReimbursed,
  NotifyEEForExpenseSubmission = 11,
  ShowPerksRenewalBanner = 12,
  ShowNonEligibleEmployeeLegalDocumentAlert = 13,
  NotifyEEForIneligibleExpense = 14,
  NotifyEEForActionNeeded = 15,
  NotifyEEForVerifiedExpense = 16,
  ExpensePremiumSubmissionSMSOptIn = 17,
  SmsTracking = 18,
  ShowNewDesignForBenefitDetails = 22,
}

export default FeatureFlag
